import React, { useState } from 'react';
import { Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { AuthService } from '../../services/api';

const Login: React.FC = () => {
  const { login, error } = useAuth();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      await login(identifier, password);
      try {
        await AuthService.PHPcodeLogin(identifier, password);
      } catch (phpErr) {
        // Silently proceed even if legacy PHP bridge fails
      }
      navigate('/dashboard');
    } catch (err) {
      // No need to set error here; it's handled by AuthContext
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}
      
      <Form.Group className="mb-3" controlId="formIdentifier">
        <Form.Label>Username or Email</Form.Label>
        <Form.Control 
          type="text"
          required
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          placeholder="Enter your username or email address"
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formPassword">
        <Form.Label>Password</Form.Label>
        <div className="input-group">
          <Form.Control 
            type={showPassword ? 'text' : 'password'}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
          />
          <Button variant="outline-secondary" onClick={() => setShowPassword(!showPassword)} className="ms-2">
            {showPassword ? 'Hide' : 'View'}
          </Button>
        </div>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formRememberMe">
        <Form.Check 
          type="checkbox" 
          label="Remember me" 
          checked={rememberMe}
          onChange={(e) => setRememberMe(e.target.checked)}
        />
      </Form.Group>

      <Button 
        variant="primary" 
        type="submit" 
        className="w-100 mb-3"
      >
        Sign In
      </Button>

      <Row className="mt-3">
        <Col xs={12} sm={6} className="mb-2 mb-sm-0">
          <Link to="/forgot-password" className="text-decoration-none">
            Forgot password?
          </Link>
        </Col>
        <Col xs={12} sm={6} className="text-sm-end">
          <Link to="/register" className="text-decoration-none">
            Don't have an account? Sign Up
          </Link>
        </Col>
      </Row>
    </Form>
  );
};

export default Login; 